<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="sport"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      @add="showAddModal()"
      @edit="showEditModal($event.id)"
      @delete="showDeleteDialog($event.id)"
    />

    <sport-modal :show="showModal" :id="idToEdit" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import ComponentTable from '@/components/table/Table';
import SportModal from '@/components/modals/SportModal';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';

// @vuese
// Lista dyscyplin
// @group Sport
export default {
  mixins: [
    listMixin('sport', {
      listError: 'messages.sport.listError',
      getError: 'messages.sport.getError',
      added: 'messages.sport.added',
      addError: 'messages.sport.addError',
      updated: 'messages.sport.updated',
      updateError: 'messages.sport.updateError',
      deleteConfirm: 'messages.sport.deleteConfirm',
      deleted: 'messages.sport.deleted',
      deleteError: 'messages.sport.deleteError'
    })
  ],
  components: { ComponentTable, SportModal },

  data() {
    return {
      columns: [{ name: 'name', displayName: 'columns.name' }],
      actions: DEFAULT_TABLE_ACTIONS
    };
  }
};
</script>